import React from 'react'
import { Outlet } from "react-router-dom";

//Landing Etiquetas
import FooterLandingEtiquetas from './components/FooterLandingEtiquetas';
import NavbarLandingEtiquetas from './components/NavbarLandingEtiquetas';


function LandingEtiquetasLayout() {
  return (
    <>
      <NavbarLandingEtiquetas />
      <main>
        <Outlet />
      </main>
      <FooterLandingEtiquetas />
    </>
  )
}

export default LandingEtiquetasLayout
